import React from 'react';
import axios from "axios";
import { useParams } from 'react-router-dom';
import { Tabs, Badge } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { menuListOW, role, subMenuProject, utils, BE_API_ONE } from "../../utils/globalVariables";
import { numberWithComma, safeValue } from "../../utils/globalFunctions";

import { useLoginContext } from "../../context/loginContext";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import GaransiIndex from "../../pagesSub/trxGaransiStep1/GaransiIndex";
import GaransiStep2Index from "../../pagesSub/trxGaransiStep2/GaransiStep2Index";
import GaransiHistoryIndex from "../../pagesSub/trxGaransiHistory/GaransiHistoryIndex";

import ProjectNotaIndex from "../../pagesSub/trxProjectNota/ProjectNotaIndex";
import ProjectAntrianIndex from "../../pagesSub/trxProjectAntrian/ProjectAntrianIndex";
import ProjectPengerjaanIndex from "../../pagesSub/trxProjectPengerjaan/ProjectPengerjaanIndex";
import ProjectQCIndex from "../../pagesSub/trxProjectQC/ProjectQCIndex";
import SelesaiIndex from "../../pagesSub/trxSelesai/SelesaiIndex";
import SudahDiambilIndex from "../../pagesSub/trxSudahDiambil/SudahDiambilIndex";
import ProjectDibatalkanIndex from "../../pagesSub/trxDibatalkan/ProjectDibatalkanIndex";

import DeliveryJemputNotaIndex from "../../pagesSub/trxDeliveryNota/DeliveryJemputNotaIndex";
import SegeraJemputIndex from "../../pagesSub/trxDeliverySegeraJemput/SegeraJemputIndex";
import SedangJemputIndex from "../../pagesSub/trxDeliverySedangJemput/SedangJemputIndex";
import SudahInputIndex from "../../pagesSub/trxDeliverySudahInput/SudahInputIndex";
import SudahSerahTerimaIndex from "../../pagesSub/trxDeliverySudahSerahTerima/SudahSerahTerimaIndex";
import DeliveryJemputBatalIndex from "../../pagesSub/trxDeliveryJemputDibatalkan/DeliveryJemputBatalIndex";

// import PopUpTeknisiTasks from "../../components/utilities/PopUpTeknisiTasks";
import PengecekanIndex from "../../pagesSub/home/pengecekan/PengecekanIndex";
import BobotKerjaTeknisiIndex from "../../pagesSub/home/bobotKerjaTeknisi/BobotKerjaTeknisiIndex";
import ReminderProjectIndex from "../../pagesSub/home/reminderProject/ReminderProjectIndex";
import SortingPriorityIndex from "../../pagesSub/sortingPriority/SortingPriorityIndex";

import SerialNumberCheckerIndex from "../../pagesSub/serialNumberChecker/SerialNumberCheckerIndex";

const ProjectOW = () => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'projectOW-1',
  })

  const { subMenu, tab } = useParams();
  const menu = menuListOW.project.slug;
  const roleUser = role.owner;
  const slugLink = roleUser.subLevel.owner.slugLink;

  const [data, setData] = React.useState({
    dataLoading: false,
    dataRefresh: new Date(),

    numberNota: '..',
    numberAntrian: '..',
    numberPengerjaan: '..',
    numberQC: '..',
    numberSelesai: '..',
    numberSudahDiambil: '..',
    numberDibatalkan: '..',
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    if (subMenuProject === subMenu) {
      setData(d => ({ ...d, dataLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);

      formDT.append('array_step_process', JSON.stringify([
        utils.projectProcess.nota.value,
        utils.projectProcess.antrian.value,
        utils.projectProcess.pengerjaan.value,
        utils.projectProcess.qc.value,
        utils.projectProcess.selesai.value,
        utils.projectProcess.sudah_diambil.value,
        // utils.projectProcess.dibatalkan.value,
      ]));

      // formDT.append('project_is_cancel', 0);

      axios({
        method: 'post',
        url: BE_API_ONE + '/step_project_counter',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataLoading: false }));

        if (response.data.flag_status === 'isset') {
          if (Object.keys(response.data.data).length > 0) {
            setData(d => ({
              ...d,
              numberNota: safeValue(response.data.data?.nota?.project_status_count, '0'),
              numberAntrian: safeValue(response.data.data?.antrian?.project_status_count, '0'),
              numberPengerjaan: safeValue(response.data.data?.pengerjaan?.project_status_count, '0'),
              numberQC: safeValue(response.data.data?.qc?.project_status_count, '0'),
              numberSelesai: safeValue(response.data.data?.selesai?.project_status_count, '0'),
              numberSudahDiambil: safeValue(response.data.data?.sudah_diambil?.project_status_count, '0'),
              numberDibatalkan: safeValue(response.data.data?.canceled?.project_status_count, '0'),

              // numberNota: Number(data.data?.nota.project_status_count ? data.data?.nota.project_status_count : 0),
              // numberAntrian: Number(data.data?.antrian.project_status_count ? data.data?.antrian.project_status_count : 0),
              // numberPengerjaan: Number(data.data?.pengerjaan.project_status_count ? data.data?.pengerjaan.project_status_count : 0),
              // numberQC: Number(data.data?.qc.project_status_count ? data.data?.qc.project_status_count : 0),
              // numberSelesai: Number(data.data?.selesai.project_status_count ? data.data?.selesai.project_status_count : 0),
              // numberSudahDiambil: Number(data.data?.sudah_diambil.project_status_count ? data.data?.sudah_diambil.project_status_count : 0),
              // numberDibatalkan: Number(data.data?.canceled.project_status_count ? data.data?.canceled.project_status_count : 0),
            }));
          }
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataLoading: false,
        }));

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [
    handleSetLoginContext,
    loginContext.syswebapp,
    subMenu,
    data.dataRefresh,

    // data.data,

    // data.data?.nota.project_status_count,
    // data.data?.antrian.project_status_count,
    // data.data?.pengerjaan.project_status_count,
    // data.data?.qc.project_status_count,
    // data.data?.selesai.project_status_count,
    // data.data?.sudah_diambil.project_status_count,
    // data.data?.canceled.project_status_count
  ])

  const fnRefreshCallBack = React.useCallback(() => {
    setData(d => ({ ...d, dataRefresh: new Date() }));
  }, [])

  return (
    <LayoutAppShell
      stateMenuList={menuListOW}
      stateMenu={menu}
      stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
    >
      {menuListOW.project.subMenu.zero.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListOW}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />

            <WrapperTab
              stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
              stateKeepMounted={false}
            >
              <Tabs.Tab value={menuListOW.project.subMenu.zero.tabs.one.flag}>
                {menuListOW.project.subMenu.zero.tabs.one.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.zero.tabs.two.flag}>
                {menuListOW.project.subMenu.zero.tabs.two.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.zero.tabs.three.flag}>
                {menuListOW.project.subMenu.zero.tabs.three.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.zero.tabs.four.flag}>
                {menuListOW.project.subMenu.zero.tabs.four.name}
              </Tabs.Tab>
            </WrapperTab>
          </WrapperHeaderTab>

          <Tabs value={tab} keepMounted={false}>
            <Tabs.Panel value={menuListOW.project.subMenu.zero.tabs.one.flag}>
              <PengecekanIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.zero.tabs.two.flag}>
              <BobotKerjaTeknisiIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.zero.tabs.three.flag}>
              <ReminderProjectIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.zero.tabs.four.flag}>
              <SortingPriorityIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>
          </Tabs>

          {/* <PopUpTeknisiTasks /> */}
        </React.Fragment>
      }

      {menuListOW.project.subMenu.one.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListOW}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />

            <WrapperTab
              stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
              stateKeepMounted={false}
            >
              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.one.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberNota)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.one.name}
              </Tabs.Tab>

              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.two.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberAntrian)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.two.name}
              </Tabs.Tab>

              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.three.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberPengerjaan)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.three.name}
              </Tabs.Tab>

              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.four.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberQC)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.four.name}
              </Tabs.Tab>

              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.five.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberSelesai)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.five.name}
              </Tabs.Tab>

              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.six.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberSudahDiambil)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.six.name}
              </Tabs.Tab>

              <Tabs.Tab
                value={menuListOW.project.subMenu.one.tabs.seven.flag}
                rightSection={
                  <Badge
                    sx={(tema) => ({
                      pointerEvents: 'none',
                    })}
                    variant="filled"
                    size="xs"
                  >
                    {numberWithComma(data.numberDibatalkan)}
                  </Badge>
                }
              >
                {menuListOW.project.subMenu.one.tabs.seven.name}
              </Tabs.Tab>
            </WrapperTab>
          </WrapperHeaderTab>

          <Tabs value={tab} keepMounted={false}>
            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.one.flag}>
              <ProjectNotaIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.two.flag}>
              <ProjectAntrianIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.three.flag}>
              <ProjectPengerjaanIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.four.flag}>
              <ProjectQCIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.five.flag}>
              <SelesaiIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.six.flag}>
              <SudahDiambilIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.one.tabs.seven.flag}>
              <ProjectDibatalkanIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={fnRefreshCallBack}
              />
            </Tabs.Panel>
          </Tabs>
        </React.Fragment>
      }

      {menuListOW.project.subMenu.two.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListOW}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />

            <WrapperTab
              stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
              stateKeepMounted={false}
            >
              <Tabs.Tab value={menuListOW.project.subMenu.two.tabs.one.flag}>
                {menuListOW.project.subMenu.two.tabs.one.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.two.tabs.two.flag}>
                {menuListOW.project.subMenu.two.tabs.two.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.two.tabs.three.flag}>
                {menuListOW.project.subMenu.two.tabs.three.name}
              </Tabs.Tab>
            </WrapperTab>
          </WrapperHeaderTab>

          <Tabs value={tab} keepMounted={false}>
            <Tabs.Panel value={menuListOW.project.subMenu.two.tabs.one.flag}>
              <GaransiIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.two.tabs.two.flag}>
              <GaransiStep2Index
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.two.tabs.three.flag}>
              <GaransiHistoryIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>
          </Tabs>
        </React.Fragment>
      }

      {menuListOW.project.subMenu.serialNumberChecker.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListOW}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />
          </WrapperHeaderTab>

          <SerialNumberCheckerIndex
            stateMenu={menu}
            stateSubMenu={subMenu}
            stateTab={tab}
          />
        </React.Fragment>
      }

      {menuListOW.project.subMenu.three.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListOW}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />

            <WrapperTab
              stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
              stateKeepMounted={false}
            >
              <Tabs.Tab value={menuListOW.project.subMenu.three.tabs.one.flag}>
                {menuListOW.project.subMenu.three.tabs.one.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.three.tabs.two.flag}>
                {menuListOW.project.subMenu.three.tabs.two.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.three.tabs.three.flag}>
                {menuListOW.project.subMenu.three.tabs.three.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.three.tabs.four.flag}>
                {menuListOW.project.subMenu.three.tabs.four.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.three.tabs.five.flag}>
                {menuListOW.project.subMenu.three.tabs.five.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListOW.project.subMenu.three.tabs.six.flag}>
                {menuListOW.project.subMenu.three.tabs.six.name}
              </Tabs.Tab>
            </WrapperTab>
          </WrapperHeaderTab>

          <Tabs value={tab} keepMounted={false}>
            <Tabs.Panel value={menuListOW.project.subMenu.three.tabs.one.flag}>
              <DeliveryJemputNotaIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.three.tabs.two.flag}>
              <SegeraJemputIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.three.tabs.three.flag}>
              <SedangJemputIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.three.tabs.four.flag}>
              <SudahInputIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.three.tabs.five.flag}>
              <SudahSerahTerimaIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListOW.project.subMenu.three.tabs.six.flag}>
              <DeliveryJemputBatalIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>
          </Tabs>
        </React.Fragment>
      }
    </LayoutAppShell>
  )
}

export default ProjectOW;